module.exports = __webpack_public_path__ + "img/Minus.91b5c618.svg";